import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Spinner,
    Progress,
    Table, Input
} from "reactstrap"
import { accessRole } from '../../../../helpers/access_role'
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import YearSelect from '../../../../helpers/ui/YearSelect'
import Select from '../../../../helpers/ui/CustomSelect'
import { Preview, FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvField, AvGroup, AvCheckboxGroup, AvCheckbox, AvInput } from "availity-reactstrap-validation"

import { Redirect, Link, withRouter } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'
import Shimmer from 'react-shimmer-effect'

import ApproveBloc from './Blocs/ApproveBloc'

let peg_uuid = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_uuid : "";

class ApproveView extends Component {

    source
    defaultSize = 10
    approveBloc = new ApproveBloc();
    timer

    constructor(props) {
        super(props)
        this.state = {
            detail: null,
            typeOption: [],
            employeeOption: [],
            awardFilter: {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: 'type_of_award_name',
                        order: 'asc' 
                    }
                },
            employeeFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'employee_id',
                    order: 'asc' 
                }
            }
        }
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                award_award_period_uuid: this.props.uuid,
                uuid: this.props.award_uuid,
                ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        const dataForm = generateFormData(this.state.dataForm, 'document')
        await this.approveBloc.fetchApprove(dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }



    loadAwardType = async () => {
        let offset = (this.state.awardFilter.page_number-1)*this.state.awardFilter.page_size
        const query = {
            search: this.state.awardFilter.filter_value,
            limit: this.state.awardFilter.page_size,
            offset: offset,
            order: this.state.awardFilter.sort_order.column,
            sort: this.state.awardFilter.sort_order.order,
            status: 1
        }
        await this.approveBloc.fetchType(query, this.source.token)
    }

    loadEmployee  = async () => {
        let offset = (this.state.employeeFilter.page_number-1)*this.state.employeeFilter.page_size
        const query = {
            search: this.state.employeeFilter.filter_value,
            limit: this.state.employeeFilter.page_size,
            offset: offset,
            order: this.state.employeeFilter.sort_order.column,
            sort: this.state.employeeFilter.sort_order.order,
            status: 1
        }
        await this.approveBloc.fetchEmployeeList(query, this.source.token)
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.award_uuid,
            employee_uuid: this.props.employee_uuid,
            recomendation_uuid: this.props.recomendation_uuid
        }
        await this.approveBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadAwardType()
        this.loadEmployee()
        this.loadDetail()
    }

    componentDidMount() {
        this.setTokenAPI()

        this.approveBloc.approveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.approveBloc.typeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ typeOption: result.data.response.result })    
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.approveBloc.employeeListChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ employeeOption: result.data.response.result })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.approveBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    console.log('cek ', result.data.response)
                    this.setState({ detail: result.data.response })
                    break;
                default:
                    break;
            }
        })

    }

    componentWillUnmount() {
        this.approveBloc.approveChannel?.unsubscribe()
        this.approveBloc.typeChannel?.unsubscribe()
        this.approveBloc.employeeListChannel?.unsubscribe()
        this.approveBloc.detailListChannel?.unsubscribe()
    }


    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to={`/kepegawaian/pemberian_penghargaan.html?approve&uuid=${this.props.uuid}`}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>Rekomendasi Penghargaan</CardTitle>
                            <hr />
                            <AvForm
                                className="needs-validation"
                                onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                            >
                                <Row className="mb-3">
                                    <Label className="col-md-2 col-form-label">
                                        Pegawai 
                                    </Label>
                                    <Col md="4">
                                        <AvField 
                                            name="award_employee_uuid"
                                            value={this.props.employee_uuid}
                                            type='hidden'
                                        />
                                        { detail != null ?
                                            <Input 
                                                type="text"
                                                value={
                                                    detail?.recomended_award_uuid ?
                                                        detail?.employee_full_name
                                                        :
                                                        detail?.employee?.employee_full_name + ' - ' + detail?.employee?.employee_current_position_name
                                                }
                                                readOnly={true}
                                            />                                       
                                            :
                                            <Shimmer>
                                                <Input 
                                                    type="text"
                                                    readOnly={true}
                                                />                  
                                            </Shimmer>
                                        }
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Label className="col-md-2 col-form-label">
                                        Jenis Penghargaan
                                    </Label>
                                    <Col md="3">
                                        { detail != null ?
                                            <Select 
                                                name="award_type_of_award_uuid"
                                                errorMessage="Pilih Jenis Penghargaan"
                                                options={this.state.typeOption} 
                                                optionLabel="type_of_award_name"
                                                optionValue="type_of_award_uuid"
                                                placeholder="Pilih Jenis Penghargaan"
                                                defaultValue={detail?.award_type_of_award_uuid}
                                                isDisabled={true}
                                            />
                                            :
                                            <Shimmer>
                                                <Input 
                                                    type="text"
                                                    readOnly={true}
                                                />
                                            </Shimmer>
                                        }
                                    </Col>
                                </Row>

                               <Row className="mb-3">
                                    <Label className="col-md-2 col-form-label">
                                        No Kepres
                                    </Label>
                                    <Col md="3">
                                        <AvField 
                                            name="award_decree_number"
                                            placeholder="No Kepres..."
                                            type="text"
                                            errorMessage="Masukkan No Kepres"
                                            value={detail?.award_decree_number}
                                            validate={{ required: { value: true } }}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Label className="col-md-2 col-form-label">
                                        Tanggal Kepres
                                    </Label>
                                    <Col md="2">
                                        <AvField 
                                            name="award_decree_date"
                                            value={detail?.award_decree_date}
                                            placeholder="No Kepres..."
                                            type="date"
                                            errorMessage="Masukkan No Kepres"
                                            validate={{ required: { value: true } }}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Label className="col-md-2 col-form-label">
                                        Pejabat Penetap
                                    </Label>
                                    <Col md="4">
                                        <AvField 
                                            name="award_signatories_official"
                                            value={detail?.award_signatories_official}
                                            placeholder="Pejabat Penetap..."
                                            type="text"
                                            errorMessage="Masukkan Pejabat Penetap"
                                            validate={{ required: { value: true } }}
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Label className="col-md-2 col-form-label">
                                        Dokumen Pendukung
                                    </Label>
                                    <Col md="4">
                                        {detail?.document &&
                                            <Preview 
                                                col="5"
                                                value={detail?.document}
                                            />
                                        }
                                        <FileInput 
                                            col="5"
                                            name="document"
                                        />
                                    </Col>
                                </Row>

                                <Row className="mb-3">
                                    <Col md="2"></Col>
                                    <Col md="8">
                                        <Link to={`/kepegawaian/pemberian_penghargaan.html?approve&uuid=${this.props.uuid}`}>
                                            <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                        </Link>
                                        {' '}
                                        <Button color="success" type="submit">
                                            <i className="uil-arrow-up-right"></i> Setujui
                                        </Button>
                                    </Col>
                                </Row>

                            </AvForm>
                        </CardBody>
                    </Card>
                </Container>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/pemberian_penghargaan.html?approve&uuid=${this.props.uuid}`}/>
                : null }

            </Fragment>
        )
    }
}

export default withRouter(ApproveView);